var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.customClass,style:(`width:${_vm.width}px;height:${_vm.height}px`),attrs:{"id":_vm.id}},[_c('ul',_vm._l((_vm.tableData),function(item,iIndex){return _c('li',{key:iIndex,class:{
        li_title: iIndex == 0,
        li_body: iIndex > 0,
      }},_vm._l((item.slice(1)),function(cell,cIndex){return _c('span',{key:cIndex,style:(`background:${iIndex > 0 && iIndex < _vm.tableData.length - 1 ? _vm.summaryColors[cIndex] : 'transparent'}`)},[_c('i',[_vm._v(_vm._s(item[0]))]),_c('i',[_vm._v(_vm._s(cell))])])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }